import React, { useState, Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import ToolTip from 'react-portal-tooltip';
import { getCharacter } from 'helpers/id';
import './PortalToolTip.css';

function MouseLeaveHandler({ children, onEvent, className }) {
  return <div className={className} onMouseLeave={onEvent}>{children}</div>;
}

const PortalTooltip = (props) => {
  const [show, setShow] = useState(false);
  const {
    children,
    text,
    row,
    tooltipStyle,
    className,
    group = 'tooltip',
  } = props;

  const id = useMemo(() => `${getCharacter(row)}_${group}`, [row, group]);

  return (
    <Fragment>
      <MouseLeaveHandler className={className} onEvent={() => setShow(false)}>
        <span
          id={id}
          onFocus={() => setShow(true)}
          onMouseOver={() => setShow(true)}
        >
          {children}
        </span>
        <ToolTip
          position="top"
          align="right"
          tooltipTimeout={0}
          active={show && text !== ''}
          parent={`#${id}`}
          group="tooltip"
          style={tooltipStyle}
        >
          <div className="portal__tooltip__text">
            <p>{text}</p>
          </div>
        </ToolTip>
      </MouseLeaveHandler>
    </Fragment>
  );
};

MouseLeaveHandler.propTypes = {
  children: PropTypes.node,
  onEvent: PropTypes.func,
  className: PropTypes.string,
};

PortalTooltip.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  row: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  group: PropTypes.string,
  tooltipStyle: PropTypes.shape({}),
  className: PropTypes.string,
};

export default PortalTooltip;



// WEBPACK FOOTER //
// ./src/components/PortalToolTip/PortalToolTip.jsx